<template>
  <f7-page :page-content="false">
    <f7-navbar title="Características de items" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="ItemCaracteristica"
        :tableCode="'ITEM_CARACTERISTICAS'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="false"
        :controlsWidth="100"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/itemcaracteristicas/new/">{{$t('common.nueva')}}</a>
          <a class="link" @click="onImportClick">
            <i class="f7-icons">square_arrow_down</i>
            {{$t('itemcaracteristicas.importar')}}
          </a>
          <a class="link" @click="onExportClick">
            <i class="f7-icons">square_arrow_up</i>
            {{$t('itemcaracteristicas.exportar')}}
          </a>
          <input ref="fileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onFileSelected" />
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/itemcaracteristicas/view/${encodeURIComponent(item.id)}/`" v-tooltip="$t('common.ver')"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/itemcaracteristicas/edit/${encodeURIComponent(item.id)}/`" v-tooltip="$t('common.editar')"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)" v-tooltip="$t('common.eliminar')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import ItemCaracteristica from "./../../js/db/ItemCaracteristica.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      ItemCaracteristica,
      encodeURIComponent
    };
  },
  methods: {
    onImportClick() {
      const self = this;
      // Pregunta el modo antes de abrir el selector.
      self.$f7.dialog.create({
        title: self.$t('itemcaracteristicas.importar'),
        text: self.$t('itemcaracteristicas.import_mode_pregunta'),
        buttons: [
          { text: 'UPSERT', onClick: () => { self._pendingMode = 'UPSERT'; self.$refs.fileInput.click(); } },
          { text: 'REPLACE_ALL', color: 'red', onClick: () => {
              self.$f7.dialog.confirm(self.$t('itemcaracteristicas.import_replace_confirm'), () => {
                self._pendingMode = 'REPLACE_ALL';
                self.$refs.fileInput.click();
              });
          } },
          { text: self.$t('common.cancelar'), close: true }
        ],
        verticalButtons: true
      }).open();
    },
    onFileSelected(e) {
      const self = this;
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      const mode = self._pendingMode || 'UPSERT';
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      ItemCaracteristica.importExcel(file, mode).then((res) => {
        espera.cerrar();
        self._showResultado(res);
        if (self.$refs.rlist && self.$refs.rlist.refresh) self.$refs.rlist.refresh();
      }).catch((err) => {
        espera.cerrar();
        self.$f7.dialog.alert(typeof err === 'string' ? err : (err.message || JSON.stringify(err)),
          self.$t('itemcaracteristicas.importar'));
      });
    },
    _showResultado(res) {
      const self = this;
      const creadas = res.creadas || 0;
      const actualizadas = res.actualizadas || 0;
      const errores = res.errores || [];
      let html = '<p><b>' + self.$t('itemcaracteristicas.creadas') + ':</b> ' + creadas
        + ' &nbsp; <b>' + self.$t('itemcaracteristicas.actualizadas') + ':</b> ' + actualizadas + '</p>';
      if (errores.length) {
        html += '<p><b>' + self.$t('itemcaracteristicas.errores') + ' (' + errores.length + '):</b></p>';
        html += '<ul style="max-height:300px;overflow:auto;padding-left:18px">';
        errores.forEach((e) => {
          html += '<li><b>' + (e.sheet || '') + '</b>'
            + (e.fila ? ' (fila ' + e.fila + ')' : '') + ': ' + (e.mensaje || '') + '</li>';
        });
        html += '</ul>';
      }
      self.$f7.dialog.create({
        title: self.$t('itemcaracteristicas.import_resultado_titulo'),
        text: html,
        buttons: [{ text: 'OK', close: true }]
      }).open();
    },
    onExportClick() {
      const self = this;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      ItemCaracteristica.downloadExcel().then(() => {
        espera.cerrar();
      }).catch((err) => {
        espera.cerrar();
        self.$f7.dialog.alert(typeof err === 'string' ? err : (err.message || 'Error'),
          self.$t('itemcaracteristicas.exportar'));
      });
    }
  }
};
</script>
